<template>
  <span>
    <span v-if="withCheckpointName">
      <strong>{{checkpointName}}</strong>
      <br v-if="!inline">
    </span>
    <span v-if="withContact">
      <strong>{{shipping[checkpoint + '_contact'] || '-'}}</strong><br>
    </span>
    <span v-if="shipping.meta?.geofences?.[checkpoint]">
      <strong>{{ shipping.meta?.geofences?.[checkpoint].external_id | cleanentityprefix }}</strong>
      {{ shipping.meta?.geofences?.[checkpoint].name | cleanentityprefix }}<br>
    </span>
    <span>
      <em v-if="shipping.meta?.geofences?.[checkpoint]">{{ address }}</em>
      <span v-else>{{ address }}</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'ShippingCheckpointMicro',
  props: {
    shipping: {
      type: Object,
      required: true
    },
    checkpoint: {
      type: String,
      default: 'from'
    },
    withContact: {
      type: Boolean,
      default: false
    },
    withCheckpointName: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkpointName() {
      return this.checkpoint === 'from' ? this.$gettext('From') : this.$gettext('To')
    },
    address() {
      return this.shipping[this.checkpoint + '_address'] || this.shipping['address_' + this.checkpoint]?.formatted_address || '-'
    }
  }
}
</script>
